// Zufalls-IDs, die auch in aelteren WebViews funktionieren.
//
// `crypto.randomUUID()` gibt es erst ab Chrome/WebView 92 und nur im sicheren
// Kontext. Fehlt es, warf der Aufruf frueher mitten im Startvorgang - und weil
// das synchron in einem useEffect passierte, hat React die komplette
// Oberflaeche abgeraeumt: schwarzer Bildschirm, nichts mehr bedienbar.
// Deshalb hier eine Kette mit Rueckfallebenen statt eines nackten Aufrufs.

function randomBytes(length: number): Uint8Array {
  const bytes = new Uint8Array(length);
  const webCrypto = globalThis.crypto;
  if (webCrypto && typeof webCrypto.getRandomValues === 'function') {
    webCrypto.getRandomValues(bytes);
    return bytes;
  }
  // Notnagel: schwaecher als echter Zufall, aber unendlich besser als eine
  // App, die gar nicht erst startet.
  for (let i = 0; i < length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  return bytes;
}

/** UUID v4 - nimmt crypto.randomUUID, wenn die WebView es kann. */
export function randomId(): string {
  const webCrypto = globalThis.crypto;
  if (webCrypto && typeof webCrypto.randomUUID === 'function') {
    return webCrypto.randomUUID();
  }
  const bytes = randomBytes(16);
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // Version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // Variante
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** 24 Zufallsbytes als base64url - dasselbe Format wie die Fahrt-Tokens. */
export function randomToken(): string {
  const bytes = randomBytes(24);
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}
